;(function () {
  'use strict'
  angular.module('contrast.freemium.registration').factory(
    'freemiumRegistrationService',
    // eslint-disable-next-line angular/di-unused
    function freemiumRegistrationServiceFactory(
      $q,
      freemiumRegistrationApiConfig,
      ServiceUtils
    ) {
      'ngInject'

      return {
        validate: validate,
        activate: activate
      }

      function validate(token) {
        return freemiumRegistrationApiConfig
          .validate(token)
          .catch(ServiceUtils.handleError)
      }

      function activate(token, password) {
        return freemiumRegistrationApiConfig
          .activate({ token: token, password: password })
          .then(
            ServiceUtils.handleResolve('data', {
              log: ServiceUtils.LOGGER.SUCCESS
            })
          )
          .catch(ServiceUtils.handleError)
      }
    }
  )
})()
